var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "form",
    {
      attrs: {
        id: "cashsubmit",
        autocomplete: "off",
        method: "POST",
      },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.onSubmit.apply(null, arguments)
        },
      },
    },
    [
      _vm.actionTypeTemp === "deposit"
        ? _c(
            "div",
            {
              staticClass: "row justify-content-center",
            },
            [
              _c(
                "div",
                {
                  staticClass: "col-12 mb-1",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "col-12 text-center mt-3 text-lg",
                    },
                    [_vm._v("\n        ฝาก : เลือกธนาคาร\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "form-group my-3 row",
                    },
                    _vm._l(_vm.agentBanks, function (bank) {
                      return _c(
                        "div",
                        {
                          key: bank.id,
                          staticClass: "text-center col-4 col-md-4 col-lg-2",
                        },
                        [
                          _c("img", {
                            staticClass:
                              "max-width-200x border border-lg rounded-lg px-2 py-2 mb-1",
                            class: [
                              _vm.selectedAgentBankId === bank.id
                                ? "border-yellow"
                                : "",
                            ],
                            attrs: {
                              src: bank.logo_url,
                              alt: "",
                              width: "100%",
                              for: bank.account_number,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.selectedBank(
                                  $event,
                                  bank.bank,
                                  bank.id
                                )
                              },
                            },
                          }),
                          _c("br"),
                          _vm._v(" "),
                          _c(
                            "font",
                            {
                              class: "text-lg text-" + bank.bank,
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(bank.thai_name) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "form-group my-3",
                    },
                    [
                      _c("cash-input", {
                        attrs: {
                          "element-id": "amount",
                          "element-name": "amount",
                          "element-type": "tel",
                          "element-class": "text-center text-xl",
                          "element-placeholder": "ระบุจำนวนเงินที่ต้องการฝาก",
                          amount: _vm.amount,
                        },
                        on: {
                          updateAmountValue: _vm.updateAmountValue,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      staticClass: "text-xs text-center text-danger",
                    },
                    [
                      _vm._v(
                        "\n        ใส่ยอดเป็นจำนวนเต็ม ระบบจะทำการสุ่มทศนิยมให้ท่านอัติโนมัติ\n      "
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-4 col-lg-2 text-center mt-3",
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-dark w-100 btnValue",
                      attrs: {
                        "data-valueset": "50",
                        type: "button",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.updateAmount(50)
                        },
                      },
                    },
                    [_vm._v("\n        50\n      ")]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-4 col-lg-2 text-center mt-3",
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-dark w-100 btnValue",
                      attrs: {
                        "data-valueset": "100",
                        type: "button",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.updateAmount(100)
                        },
                      },
                    },
                    [_vm._v("\n        100\n      ")]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-4 col-lg-2 text-center mt-3",
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-dark w-100 btnValue",
                      attrs: {
                        "data-valueset": "300",
                        type: "button",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.updateAmount(300)
                        },
                      },
                    },
                    [_vm._v("\n        300\n      ")]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-4 col-lg-2 text-center mt-3",
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-dark w-100 btnValue",
                      attrs: {
                        "data-valueset": "500",
                        type: "button",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.updateAmount(500)
                        },
                      },
                    },
                    [_vm._v("\n        500\n      ")]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-4 col-lg-2 text-center mt-3",
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-dark w-100 btnValue",
                      attrs: {
                        "data-valueset": "1000",
                        type: "button",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.updateAmount(1000)
                        },
                      },
                    },
                    [_vm._v("\n        1,000\n      ")]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-4 col-lg-2 text-center mt-3",
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-dark w-100 btnValue",
                      attrs: {
                        "data-valueset": "2000",
                        type: "button",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.updateAmount(2000)
                        },
                      },
                    },
                    [_vm._v("\n        2,000\n      ")]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-12",
                },
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "d-flex py-3",
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.remark,
                            expression: "remark",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                        },
                        domProps: {
                          value: _vm.remark,
                        },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.remark = $event.target.value
                          },
                        },
                      }),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _vm._m(1),
              _vm._v(" "),
              _vm._m(2),
            ]
          )
        : _vm.actionTypeTemp === "withdraw"
        ? _c(
            "div",
            {
              staticClass: "row justify-content-center",
            },
            [
              _c(
                "div",
                {
                  staticClass: "col-12 text-center mt-3 text-lg",
                },
                [_vm._v("\n      ถอนเครดิต\n    ")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-12",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "form-group my-3",
                    },
                    [
                      _c("cash-input", {
                        attrs: {
                          "element-id": "amount",
                          "element-name": "amount",
                          "element-type": "tel",
                          "element-class": "`text-center text-xl`",
                          "element-placeholder": "ระบุจำนวนเงินที่ต้องการถอน",
                          amount: _vm.amount,
                        },
                        on: {
                          updateAmountValue: _vm.updateAmountValue,
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-12",
                },
                [
                  _vm._m(3),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "d-flex py-3",
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.remark,
                            expression: "remark",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                        },
                        domProps: {
                          value: _vm.remark,
                        },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.remark = $event.target.value
                          },
                        },
                      }),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-12 my-3 text-center small",
                },
                [_vm._v("\n      ไปยังบัญชี\n    ")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-12",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "card shadow-sm text-white",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "card-header text-center",
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: _vm.bankLogo,
                              alt: "",
                              width: "50",
                            },
                          }),
                          _c("br"),
                          _vm._v(" "),
                          _c(
                            "font",
                            {
                              class: "text-" + _vm.userBank,
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.userBankName) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "card-body",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "container",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "row",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-6 text-black text-center border-right my-3",
                                    },
                                    [
                                      _vm._v(
                                        "\n                ชื่อบัญชี\n              "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "col-6 text-center my-3",
                                      class: "text-" + _vm.userBank,
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.userBankAccount) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-6 text-black text-center border-right",
                                    },
                                    [
                                      _vm._v(
                                        "\n                เลขบัญชี\n              "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "col-6 text-center",
                                      class: "text-" + _vm.userBank,
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.userBankNumber) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _vm._m(4),
              _vm._v(" "),
              _vm._m(5),
            ]
          )
        : _c(
            "div",
            {
              staticClass: "row justify-content-center",
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "col-12 text-center mt-0 py-3 text-lg text-primary",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "card py-3",
                    },
                    [
                      _c(
                        "div",
                        {},
                        [
                          _c(
                            "div",
                            {
                              staticClass: "w-100 text-xxl",
                            },
                            [
                              _vm._v(
                                "\n            คุณมีเวลาโอนเงินภายใน\n          "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("countdown", {
                            staticClass: "w-100 text-xxl",
                            attrs: {
                              "type-countdown": "cash",
                              "seconds-left": _vm.secondsLeft,
                            },
                            on: {
                              "game-timeout": _vm.gameTimeout,
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-12 mt-3 text-xxl text-center text-dark",
                },
                [_vm._v("\n      กรุณาโอนเงินจำนวน\n    ")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-12 mt-2 text-success text-center text-h4",
                },
                [
                  _c(
                    "font",
                    {
                      staticClass: "text-dark text-xxl",
                    },
                    [_vm._v("\n        จำนวน\n      ")]
                  ),
                  _vm._v(
                    "\n\n      " +
                      _vm._s(
                        Intl.NumberFormat("th-TH", {
                          style: "currency",
                          currency: "THB",
                        }).format(_vm.transactionAmount)
                      ) +
                      "\n    "
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-12 mt-2 text-success text-center",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "card bg-light text-white",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "card-header text-white text-center text-xxl",
                          class: "bg-" + _vm.bankTransactionName,
                        },
                        [_vm._v("\n          ข้อมูลธนาคาร\n        ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "card-body py-0 text-lg",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "d-flex border-bottom py-3",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "flex-width text-center",
                                  class: "text-" + _vm.bankTransactionName,
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: _vm.bankTransactionLogo,
                                      alt: "",
                                      width: "50",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("br"),
                                  _vm._v(
                                    _vm._s(_vm.BANKS[_vm.bankTransactionName]) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "d-flex border-bottom py-3",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "text-left text-dark justify-content-between",
                                },
                                [
                                  _vm._v(
                                    "\n              ชื่อบัญชี\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("v-spacer"),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "text-right justify-content-between",
                                  class: "text-" + _vm.bankTransactionName,
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.bankTransactionAccountName) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "d-flex py-3",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "flex-width text-left text-dark",
                                },
                                [
                                  _vm._v(
                                    "\n              เลขที่บัญชี\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "flex-width text-right text-monospace",
                                  class: "text-" + _vm.bankTransactionName,
                                },
                                [
                                  _c("input", {
                                    attrs: {
                                      id: "bank-id",
                                      type: "hidden",
                                    },
                                    domProps: {
                                      value: _vm.bankTransactionAccountNumber,
                                    },
                                  }),
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.bankTransactionAccountNumber) +
                                      "\n              "
                                  ),
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn-outline-success shadow py-1",
                                      attrs: {
                                        type: "button",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.copyBankId(
                                            _vm.bankTransactionAccountNumber
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                คัดลอก\n              "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _vm._m(6),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "d-flex py-3",
                            },
                            [
                              _c(
                                "select",
                                {
                                  staticClass: "form-control py-0",
                                  attrs: {
                                    id: "date",
                                    required: "required",
                                    name: "date",
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.updateTimeOnChange($event)
                                    },
                                  },
                                },
                                _vm._l(15, function (n) {
                                  return _c(
                                    "option",
                                    {
                                      key: n,
                                      domProps: {
                                        value: _vm.evenTimes(n),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.evenTimeMinute(n)) +
                                          "\n              "
                                      ),
                                    ]
                                  )
                                }),
                                0
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-12",
                },
                [
                  _c("ul", [
                    _c(
                      "li",
                      [
                        _vm._v("\n          โปรดโอนเงินจำนวน\n          "),
                        _c(
                          "font",
                          {
                            staticClass: "text-success",
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.transactionAmount) +
                                "\n          "
                            ),
                          ]
                        ),
                        _vm._v("\n          เข้าบัญชี ที่กำหนดไว้\n        "),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("li", [
                      _vm._v(
                        "ระบบจะแจ้งยอดเงินพร้อมทศนิยมที่ท่านต้องโอน ท่านจำเป็นต้องโอนให้ตรงกับยอดนั้น ห้ามปัดเศษเด็ดขาด"
                      ),
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _vm._v(
                        "หลังจากตรวจสอบเรียบร้อยแล้ว ระบบจะทำการ เพิ่มเครดิตให้ท่าน ภายใน 5 นาที"
                      ),
                    ]),
                  ]),
                ]
              ),
            ]
          ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: {
            persistent: "",
            "max-width": "290",
          },
          model: {
            value: _vm.dialogPreload,
            callback: function ($$v) {
              _vm.dialogPreload = $$v
            },
            expression: "dialogPreload",
          },
        },
        [
          _c(
            "v-card",
            {
              attrs: {
                color: "red",
                dark: "",
              },
            },
            [
              _c(
                "v-card-text",
                [
                  _vm._v("\n        กำลังประมวลผล\n        "),
                  _c("v-progress-linear", {
                    staticClass: "mb-0",
                    attrs: {
                      indeterminate: "",
                      color: "white",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c(
      "div",
      {
        staticClass: "d-flex",
      },
      [
        _c(
          "div",
          {
            staticClass: "flex-width text-left text-dark",
          },
          [_vm._v("\n          หมายเหตุ\n        ")]
        ),
      ]
    )
  } /* staticRenderFnsSpliter */,
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c(
      "div",
      {
        staticClass: "col-4 my-5",
      },
      [
        _c(
          "button",
          {
            staticClass: "btn btn-primary w-100 shadow",
            attrs: {
              type: "reset",
            },
          },
          [_vm._v("\n        ยกเลิก\n      ")]
        ),
      ]
    )
  } /* staticRenderFnsSpliter */,
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c(
      "div",
      {
        staticClass: "col-8 my-5",
      },
      [
        _c(
          "button",
          {
            staticClass: "btn btn-green w-100 shadow",
            attrs: {
              type: "submit",
            },
          },
          [_vm._v("\n        ยืนยัน\n      ")]
        ),
      ]
    )
  } /* staticRenderFnsSpliter */,
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c(
      "div",
      {
        staticClass: "d-flex",
      },
      [
        _c(
          "div",
          {
            staticClass: "flex-width text-left text-dark",
          },
          [_vm._v("\n          หมายเหตุ\n        ")]
        ),
      ]
    )
  } /* staticRenderFnsSpliter */,
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c(
      "div",
      {
        staticClass: "col-4 my-5",
      },
      [
        _c(
          "button",
          {
            staticClass: "btn btn-primary w-100 shadow",
            attrs: {
              type: "reset",
            },
          },
          [_vm._v("\n        ยกเลิก\n      ")]
        ),
      ]
    )
  } /* staticRenderFnsSpliter */,
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c(
      "div",
      {
        staticClass: "col-8 my-5",
      },
      [
        _c(
          "button",
          {
            staticClass: "btn btn-green w-100 shadow",
            attrs: {
              type: "submit",
            },
          },
          [_vm._v("\n        ยืนยัน\n      ")]
        ),
      ]
    )
  } /* staticRenderFnsSpliter */,
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c(
      "div",
      {
        staticClass: "d-flex py-3",
      },
      [
        _c(
          "div",
          {
            staticClass: "flex-width text-left text-dark",
          },
          [_vm._v("\n              ระบุวันเวลาที่ทำรายการโอน\n            ")]
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }